import { Stack, Text } from '@mantine/core';

type DetailSectionPropsType = {
  label: string;
  children: React.ReactNode;
};

export const DetailSection: React.FC<DetailSectionPropsType> = ({
  label,
  children,
}) => (
  <Stack gap="xs">
    <Text size="xs" tt="uppercase" fw={600}>
      {label}
    </Text>
    {children}
  </Stack>
);
